import styled from 'styled-components';

export const CashierStepsStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;

export const CashierStepStyled = styled.div`
    display: flex;
    padding: 4px 4px 4px 16px;
    width: 100%;
    
    &.in-progress {
        border-radius: 16px;
        background: var(--color-surface);
        padding: 16px;
    }
`;

export const CashierStepTitleStyled = styled.div`
    font-size: 16px;
    line-height: 24px;
`;

export const CashierStepDescriptionStyled = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: var(--color-white-60);
`;

export const CashierStepStatusStyled = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
`;

export const CashierStepDividerStyled = styled.div`
    display: flex;
    padding-left: 16px;
    height: 24px;
    width: 100%;
`;

export const CashierStepDividerRectangleStyled = styled.div`
    width: 2px;
    height: 100%;
    margin-left: 11px;
    border-radius: 1px;
    background: var(--color-neutral-20);
`;
